import { required } from '@shopee/validators';
import {
  prettifyPhoneNumber,
  localMobilePhoneValidator,
} from '@shopee-user/authentication-utils';

export const FORM_CONFIG = [
  {
    name: 'authKey',
    initial: '',
    validators: [
      required('msg_auth_mandatory_field'),
      localMobilePhoneValidator('msg_auth_invalid_phone'),
    ],
    transform: prettifyPhoneNumber,
  },
];
